export default __webpack_public_path__ + "static/media/mon_64.b57e33cd.png";